import React from "react";
import UserInformationWihoutSso from "./UserInformationWihoutSso";
import { isSSO } from "App/constants";
import UserInformationSso from "./UserInformationSso";

function UserInformation({ themeList }) {
  if (isSSO) {
    return <UserInformationSso />;
  } else {
    return <UserInformationWihoutSso themeList={themeList} />;
  }
}

export default UserInformation;
